import api from './api';

/**
 * Rides monitor: one row per ride, with counts per phase.
 * params: page, limit, phase, driver, origin, destination, from, to
 */
export const getRides = async (params = {}) => {
  const response = await api.get('/rides', { params });
  return response; // Interceptor already unwraps response.data
};

/** Every seat request on one ride, oldest first. */
export const getRideBookings = async (rideId: number) => {
  const response = await api.get(`/rides/${rideId}/bookings`);
  return response; // Interceptor already unwraps response.data
};
